/* Packages */
import React from 'react';
import { render } from 'react-dom';

const smartContentOverviewNodes = Array.from(document.querySelectorAll('[data-smart-content-overview]'));
if (smartContentOverviewNodes.length) {
    import(/* webpackChunkName: "SmartContentOverview" */ './components/SmartContentOverview').then(({ default: SmartContentOverview }) => {
        smartContentOverviewNodes.forEach((node) => render(<SmartContentOverview {...(JSON.parse(node.dataset.smartContentOverview || '{}'))} />, node));
    });
}
